<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>
  </template>

  <template #toolbar>
    <ul class="legend-wrapper">
      <li><section style="background-color:#409EFF"></section><label>有需要确认动环配置的站点</label></li>
      <li><section style="background-color:#67C23A"></section><label>有动环配置的站点</label></li>
    </ul>
    <el-radio-group v-model="selfDisplayType" size="small" @change="onSelfDisplayTypeChanged">
      <el-radio-button :label="1">仪器因子</el-radio-button>
      <el-radio-button :label="2">动环配置</el-radio-button>
      <el-radio-button :label="3">动环配置确认</el-radio-button>
    </el-radio-group>
    <el-button
      v-if="isAdmin || orgTypeId === 1"
      type="orange"
      icon="el-icon-plus"
      size="small"
      @click="onOpenEditor()"
    >新建{{editName}}</el-button>
  </template>

  <template #body>
    <el-table
      ref="table"
      :data="list"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @selection-change="onSelectionChange"
      @row-click="onSelectSite"
    >
      <el-table-column label="序号" width="50" fixed>
        <template slot-scope="{$index, row}">
          <span :class="{
            highlight: envConfigSiteIdMap[row.id],
            'has-env': areaMap[row.id]
          }">{{$index + 1}}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="站房名称" fixed width="150">
        <template slot-scope="{row}">
          <span :class="{
            highlight: envConfigSiteIdMap[row.id],
            'has-env': areaMap[row.id]
          }">{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="province" label="省份" width="100">
        <template slot-scope="{row}">
          <span :class="{
            highlight: envConfigSiteIdMap[row.id],
            'has-env': areaMap[row.id]
          }">{{row.province}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="city" label="城市" width="150">
        <template slot-scope="{row}">
          <span :class="{
            highlight: envConfigSiteIdMap[row.id],
            'has-env': areaMap[row.id]
          }">{{row.city}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="categoryId" label="站房类别" width="150">
        <template slot-scope="{row}">
          <span :class="{
            highlight: envConfigSiteIdMap[row.id],
            'has-env': areaMap[row.id]
          }">{{siteCategoryMap[row.categoryId] ? siteCategoryMap[row.categoryId].name : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="enableDate" label="启用日期" width="120">
        <template slot-scope="{row}">
          <span :class="{
            highlight: envConfigSiteIdMap[row.id],
            'has-env': areaMap[row.id]
          }">{{new Date(row.enableDate).format('YYYY-MM-DD')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="samplingHeight" label="采样高度(m)" width="120" >
        <template slot-scope="{row}">
          <span :class="{
            highlight: envConfigSiteIdMap[row.id],
            'has-env': areaMap[row.id]
          }">{{row.samplingHeight ? row.samplingHeight : '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mn" label="MN" min-width="250">
        <template slot-scope="{row}">
          <span :class="{
            highlight: envConfigSiteIdMap[row.id],
            'has-env': areaMap[row.id]
          }">{{row.mn}}</span>
        </template>
      </el-table-column>

      <el-table-column label="是否启用" align="center" width="100">
        <template slot-scope="{row}">
          <my-switch
            v-model="row.status"
            @click.native.stop
            @change="onChangeStatus(row, ...arguments)"
          />
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="{row}">
          <div class="table-operator-wrapper">
            <span class="table-operator-btn edit-btn" @click="onOpenEditor(row)">
              <i class="el-icon-edit" aria-hidden="true"></i>
            </span>
            <span v-if="isAdmin" class="table-operator-btn delete-btn" @click.stop="onShowDeleteConfirmDialog(row)">
              <i class="el-icon-delete" aria-hidden="true"></i>
            </span>
<!--            <span class="table-operator-btn qc-settings-btn" @click.stop="onQCSettingsBtnClick(row)">-->
<!--              <i class="el-icon-setting" aria-hidden="true"></i>-->
<!--            </span>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
  </template>

  <template #footer>
    <p style="margin: 0; text-align:center;" @click="showFull"><span :class="`${flag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'}`"></span></p>
  </template>

  <template #editor>
    <site-editor
      ref="editor"
      :owner-orgs="orgs"
      @save="onSiteSave"
    />

    <q-c-factor-category-editor
      ref="qc-factor-category-editor"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../BaseListEditor'
import SiteEditor from './SiteEditor'
import LayoutContent from '../../../components/Layout/Content'
import QCFactorCategoryEditor from './QCFactorCategoryEditor'
import {mapGetters} from 'vuex'

export default {
  name: 'SiteListEditor',
  extends: BaseListEditor,
  components: {QCFactorCategoryEditor, LayoutContent, SiteEditor},
  props: {
    displayType: {
      required: true,
      type: Number
    },
    currentDisplaySite: {
      required: true,
      type: Object
    },
    envConfigSiteIdMap: {
      required: true
    }
  },
  data () {
    return {
      flag: false,
      orgs: Object.freeze([]),
      selfDisplayType: this.displayType
    }
  },
  computed: {
    ...mapGetters({
      orgTypeId: 'Profile/orgTypeId',
      areaMap: 'EnvFactor/areaMap'
    })
  },
  methods: {
    showFull () {
      this.flag = !this.flag
      this.$eventBus.emit('setShowFullFlag', this.flag ? 1 : 0)
    },
    setList (list) {
      this.list = list || []
    },
    onSelectSite (site) {
      this.selectSite(site)
    },
    selectSite (site) {
      let {currentSite} = this

      if (!currentSite || currentSite.id !== site.id) {
        this.currentSite = site
        this.$emit('update:currentDisplaySite', Object.freeze(JSON.parse(JSON.stringify(site))))
      }

      this.$nextTick(() => {
        let table = this.getTable()

        if (table) {
          let id = site.id
          let tableData = table.tableData.find(site => site.id === id)
          table.setCurrentRow(tableData)
        }
      })
    },
    onSiteSave (site) {
      this.site = site
      this.getList()
    },
    afterQuery () {
      let {site} = this

      if (site) {
        this.selectSite(site)
        this.org = null
      } else {
        let {list} = this
        this.selectSite(list.length > 0 ? list[0] : {
          id: null
        })
      }
    },
    onQCSettingsBtnClick (site) {
      this.$refs['qc-factor-category-editor'].open(site)
    },
    onSelfDisplayTypeChanged (displayType) {
      this.$emit('update:displayType', displayType)
    }
  },
  created () {
    this.$api.Org.getList({
      typeId: 1
    }).then(orgs => {
      this.orgs = Object.freeze(orgs)
    }).catch(console.error)
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.qc-settings-btn {
  &:after {
    content: "质控";
  }
}

.legend-wrapper {
  font-size: 13px;
  display: flex;
  gap: 10px;
  margin: 0;
  padding: 0;
  color: #303133;
  list-style: none;
  -webkit-font-smoothing: antialiased;

  > li {
    --legend-section-size: 10px;

    display: grid;
    grid-template-columns: var(--legend-section-size) max-content;
    grid-column-gap: 3px;
    align-items: center;

    > section {
      padding-top: 100%;
    }
  }
}

.has-env {
  color: #67C23A;
}

.highlight {
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/SiteListEditor.vue